export default __webpack_public_path__ + "static/media/win.d13227ce.mp3";